import { render } from "./TabSwiper.vue?vue&type=template&id=9dd60c5e&scoped=true"
import script from "./TabSwiper.vue?vue&type=script&lang=js"
export * from "./TabSwiper.vue?vue&type=script&lang=js"

import "./TabSwiper.vue?vue&type=style&index=0&id=9dd60c5e&scoped=true&lang=scss"

import exportComponent from "/Users/huangli/Desktop/未命名文件夹 2/borun/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dd60c5e"]])

export default __exports__